module.exports = __webpack_public_path__ + "static/media/letterM.15b45d21.svg";